import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is cookie-based (httpOnly marqolix_token set by /auth/login).
// `withCredentials: true` makes axios include the cookie cross-origin.
// We no longer read/write any token from localStorage (iter14 — security).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Read the (non-httpOnly) CSRF cookie set by /auth/login. We re-read on
// every request because logout/login may rotate it.
function readCsrfCookie() {
  const match = document.cookie.match(/(?:^|;\s*)marqolix_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

// Attach X-CSRF-Token on every state-changing request. The server uses
// the double-submit-cookie pattern: header must equal cookie value.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = readCsrfCookie();
    if (token) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = token;
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
